import { render, staticRenderFns } from "./PropertyDetail.vue?vue&type=template&id=0090c16c&scoped=true&"
import script from "./PropertyDetail.vue?vue&type=script&lang=js&"
export * from "./PropertyDetail.vue?vue&type=script&lang=js&"
import style0 from "./PropertyDetail.vue?vue&type=style&index=0&id=0090c16c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0090c16c",
  null
  
)

component.options.__file = "PropertyDetail.vue"
export default component.exports